<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <b-navbar class="nav-banner" fixed="top">
          <v-layout row wrap align-center p-1 pl-2 pr-2 class="nav-row1">
            <v-flex class="study-header" xs12 md7 row>
              <img
                class="logo_brand mr-2"
                src="../assets/NSF_Logo_flat.png"
                width="25px"
                height="25px"
                alt="NSF Logo"
              />
              <div
                class="banner-text-row1-bold"
              >NSF Survey of Federal Funds for Research and Development</div>
            </v-flex>

            <!-- Right aligned nav items -->
            <v-flex xs12 md5 row class="nav-banner-right">
              <div class="office-name"> {{ officeDescription }} <span> {{sequenceNumber}} </span> <span> {{ departmentType }} </span></div>
              <div class="logout-block" tabindex="0">
                <a class="sign-out" href="#" @click="logout">Sign Out</a>
              </div>
            </v-flex>
          </v-layout>
        </b-navbar>
      </v-layout>
    </v-container>

    <br /><br />
  </div>
</template>

<script>
import Vue from "vue";
import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import { CONSTANTS } from "../common/constants";
import router from "@/router";
import { officeManagementService } from "@/services/officeManagementService.js";
//import { NavBar } from "@/components/NavBarHome.vue";
export default {
  name: "NavBarHome",
  data: () => ({
    officeDescription: "",
    departmentType: "",
    sequenceNumber:null,
  }),
  methods: {
    logout() {
      authService.logout();
			this.clearCache();
    },
    admin() {
      router.push({ name: "admin" });
    },
    officemanagement() {
      router.push({ name: "officemanagement" });
    },
		clearCache(){
			location.reload();
		}
  },
  mounted() {
    debugger;
    console.log("Calling..");
    const me = this;
    const claims = authTokenService.getClaims();
    console.log("Calling..",claims.surveyId);
    data: () => ({
       FYVolume: null,
    });
    me.FYVolume =  authTokenService.getFYVolume();
    if(me.FYVolume == null)
    {
      me.FYVolume = "Volume 72 (FYs 2023 - 24)";
    }
    if(claims.surveyId!=undefined)
    {
      console.log("Calling..",claims.surveyId);
      var activeId = authTokenService.getActiveSurveyId();
      if(activeId==null)
      {
        activeId=claims.surveyId;
      }
      officeManagementService
        .getOfficeBySurveyId(activeId)
        .then(function(response) {
          if (response && response.data) {
            console.log("Calling..",claims.surveyId);
            console.log("Calling..",response.data);
            if(response.data.agency!="00000" && response.data.program == "00000" && (response.data.field == "00000" || response.data.field == "0000" || response.data.field == "000") && (response.data.branch == "00000" || response.data.branch == "0000" || response.data.branch == "000"))
            {
              me.departmentType="(Agency)";
            }
            else if(response.data.agency!="00000" && response.data.program != "00000" && (response.data.field == "00000" || response.data.field == "0000" || response.data.field == "000") && (response.data.branch == "00000" || response.data.branch == "0000" || response.data.branch == "000"))
            {
              me.departmentType="(Program)";
            }
            else if(response.data.agency!="00000" && response.data.program != "00000" && (response.data.field != "00000" || response.data.field != "0000" || response.data.field != "000") && (response.data.branch == "00000" || response.data.branch == "0000" || response.data.branch == "000"))
            {
              me.departmentType="(Field)";
            }
            else
            {
              me.departmentType="(Branch)";
            }
            me.officeDescription = response.data.officeName;
            me.sequenceNumber= "("+response.data.agency+"-"+response.data.program+"-"+response.data.field+"-"+response.data.branch+")";
          }
          else
            me.officeDescription="";
        }).catch(function (error) {
              me.officeDescription="";
        });
    }
    else
    {
       me.officeDescription="";
    }
  }
};
</script>

<style scoped>
.bannerX {
  margin: 0;
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #0f5182;
  flex-direction: column;
  align-items: stretch;
  box-shadow: 0 0 5px grey;
  font-family: Calibri(body), Cambria, Cochin, Georgia, Times, serif;
  color: white;
}
.row1 {
  align-items: center;
}
.banner-text-row1-bold {
  font-size: 13pt;
  font-weight: bold;
}
.banner-text-row1 {
  font-size: 11pt;
  font-weight: normal;
  align-items: center;
}
</style>
